import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";
import {
  BACKGROUND_IMAGE_PATH_PSYCH,
  BRAND_LOGO,
  BRAND_LOGO_FULL_NAME,
  getMediaContent,
  OPACITY_OVERLAY,
} from "./components";

export const TITLE_MASTER_PSYCH = "TITLE_MASTER_PSYCH";

export const titleMasterSlidePsych: PptxGenJS.SlideMasterProps = {
  title: TITLE_MASTER_PSYCH,
  background: {
    color: "#FFFFFF",
    transparency: 0.6,
    data: getMediaContent(BACKGROUND_IMAGE_PATH_PSYCH),
  },
  objects: [
    OPACITY_OVERLAY,
    BRAND_LOGO_FULL_NAME,
    {
      placeholder: {
        options: {
          name: "title",
          type: "title",
          x: 0.94,
          y: 2.85,
          w: 12.29,
          h: 1.9,
          fontSize: 65,
          align: "left",
          valign: "bottom",
        },
        text: "Title",
      },
    },
    {
      placeholder: {
        options: {
          name: "candidate-name",
          type: "body",
          x: 0.94,
          y: 4.96,
          w: 8.51,
          h: 0.39,
          fontSize: 18,
          align: "left",
        },
        text: "Candidate Name",
      },
    },
    {
      placeholder: {
        options: {
          name: "created-by",
          type: "body",
          x: 0.94,
          y: 5.35,
          w: 8.51,
          h: 0.77,
          fontSize: 18,
          align: "left",
        },
        text: "Prepared by: RRA Consultant Name",
      },
    },
    {
      placeholder: {
        options: {
          name: "date",
          type: "body",
          x: 0.94,
          y: 6.96,
          w: 4.93,
          h: 0.3,
          fontSize: 14,
          align: "left",
          bold: true,
          color: "#0a2fb5",
        },
        text: dayjs().format("MMMM YYYY"),
      },
    },
  ],
};
